module.exports = __webpack_public_path__ + "static/3_2_bayes-rule-2-2508e993b33b6a7dd06c7644ef8cbd1f.svg";